export * as Queries from './queries'
